<script setup>
import { useI18n } from "vue-i18n";
import { FormRadioGroup, FormRadioGroupOption, FormInput } from "@Components/Form";
import { LayoutGridIcon, LayoutRowIcon } from "@Icons/index";

defineProps(["modelValue"]);
defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();

const displayModes = [
    {
        key: "inline",
        name: __("Liste"),
        description: __("Affichage sous la forme d'une liste."),
        icon: LayoutRowIcon,
    },
    {
        key: "grid",
        name: __("Grille"),
        description: __("Affichage sous la forme d'une grille."),
        icon: LayoutGridIcon,
    },
];
</script>

<template>
    <div class="space-y-6">
        <FormRadioGroup v-model="modelValue.display_mode" :label="__('Mode d\'affichage')">
            <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-1 2xl:grid-cols-2">
                <FormRadioGroupOption
                    v-for="mode in displayModes"
                    :key="mode.key"
                    :value="mode.key"
                    :icon="mode.icon"
                    :title="mode.name"
                    :description="mode.description"
                />
            </div>
        </FormRadioGroup>

        <div v-if="modelValue.display_mode === 'grid'" class="max-w-xs">
            <FormInput v-model="modelValue.settings.grid.columns" type="number" :label="__('Nombre de colonnes')" min="1" max="4" />
        </div>
    </div>
</template>
